import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-linkedin',
    templateUrl: './linkedin.component.html',
    styleUrls: ['./linkedin.component.scss'],
    standalone: true
})
export class LinkedinComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
